import ColorButton from "./color-button";
import { CollorButtonsContainer } from "./styles";

export default function ColorButtons({
  currentColor,
  setCurrentColor,
  center = true,
  border = false,
}) {
  return (
    <CollorButtonsContainer center={center} border={border}>
      {[...Array(5).keys()].map((_, i) => (
        <ColorButton
          currentColor={currentColor}
          id={i + 1}
          setColor={setCurrentColor}
          key={i}
        />
      ))}
    </CollorButtonsContainer>
  );
}
